import React from 'react'

export default function ImageLicencePage() {
  return (
    <div>LicencePage</div>
  )
}
